import React from 'react'
import { forwardRef } from 'react'
import { Radio, RadioGroupProps } from 'antd'
import cl from 'classnames'

import styles from './styles.module.scss'

const RadioButtonGroup = forwardRef<HTMLDivElement, RadioGroupProps>(
	({ className, optionType = 'default', ...props }, ref) => {
		return (
			<Radio.Group
				{...props}
				className={cl(styles.basicRadioGroup, className)}
				optionType={optionType}
				ref={ref}
			/>
		)
	}
)

export default RadioButtonGroup
